import {Outlet, createFileRoute} from "@tanstack/react-router";
import {TuffexDevtoolsClient, TuffexDevtoolsClientContext} from "~/contexts/ottokart/tuffexDevtoolsClientContext";
import {WorkspaceConfigScaffold} from "~/workspaceConfig/workspaceConfigScaffold";

/**
 * Pathless layout: `/w/$workspaceId/$pageKey` serves config-driven workspace pages by id + type.
 */
export const Route = createFileRoute(
    "/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_configScaffold",
)({
    component: RouteComponent,
});

const tuffexDevtoolsClient = new TuffexDevtoolsClient();

function RouteComponent() {
    return (
        <TuffexDevtoolsClientContext.Provider value={tuffexDevtoolsClient}>
            <WorkspaceConfigScaffold>
                <Outlet />
            </WorkspaceConfigScaffold>
        </TuffexDevtoolsClientContext.Provider>
    );
}
